import { deniedStates, pendingStates } from 'components/manageBoat/utils';
import styled from 'styled-components';

export default function BoatStatusBadge({ state, activated }: { state?: string; activated: boolean }) {
  const getLabelColor = () => {
    if (state === 'active' || state === 'approved') return '#2A8500';
    if (state === 'inactive') return '#5E696A';
    if (state === 'incomplete') return '#8E9697';
    if (pendingStates.includes(state)) return '#F5ECE4';
    if (deniedStates.includes(state)) return '#BC350A';
  };

  const getNiceLabel = () => {
    if (!activated && state === 'approved') return 'inactive';
    if (state === 'approved') return 'active';
    if (pendingStates.includes(state)) return 'pending';
    if (deniedStates.includes(state)) return 'denied';
    return state;
  };

  return (
    <Badge bgColor={getLabelColor()} className={state}>
      {getNiceLabel()}
    </Badge>
  );
}

const Badge = styled.span<{ bgColor: string }>`
  background: ${({ bgColor }) => bgColor};
  border-radius: 3px;
  color: white;
  font-weight: bold;
  font-size: 10px;
  text-align: center;
  width: fit-content;
  padding: 3px 8px;
  margin-bottom: 10px;
  text-transform: uppercase;

  &.pending_review,
  &.corrections_needed,
  &.survey_received,
  &.pending_insurance,
  &.pending_survey {
    color: #17233c;
  }
`;
